/* ── Outfit Builder ─────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var cfg   = window.OUTFIT_BUILDER_CONFIG;
  var slots = window.OUTFIT_BUILDER_SLOTS;
  if (!cfg || !slots) return;

  var chosen   = {};
  var outfitId = 'outfit-' + cfg.productId + '-' + Date.now();

  function fmt(cents) {
    if (window.Shopify && Shopify.formatMoney && Shopify.moneyFormat) {
      return Shopify.formatMoney(cents, Shopify.moneyFormat);
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function getDiscount(count) {
    var best  = 0;
    var tiers = cfg.tiers.slice().sort(function (a, b) { return b.count - a.count; });
    for (var i = 0; i < tiers.length; i++) {
      if (count >= tiers[i].count) { best = tiers[i].pct; break; }
    }
    return best;
  }

  function getNextTier(count) {
    var tiers = cfg.tiers.slice().sort(function (a, b) { return a.count - b.count; });
    for (var i = 0; i < tiers.length; i++) {
      if (count < tiers[i].count) return tiers[i];
    }
    return null;
  }

  function maxPct() {
    if (!cfg.tiers.length) return 0;
    return cfg.tiers.slice().sort(function (a, b) { return b.pct - a.pct; })[0].pct;
  }

  function countAdded() {
    var n = 1;
    Object.keys(chosen).forEach(function (c) { if (chosen[c]) n++; });
    return n;
  }

  function totals() {
    var sub = cfg.productPrice;
    Object.keys(chosen).forEach(function (c) { if (chosen[c]) sub += chosen[c].price; });
    var pct  = getDiscount(countAdded());
    var disc = Math.round(sub * pct / 100);
    return { subtotal: sub, pct: pct, discount: disc, total: sub - disc };
  }

  function sizeSelect(variants, rowId) {
    var opts = variants.map(function (v) {
      return '<option value="' + v.id + '" data-price="' + v.price + '"'
        + (v.available ? '' : ' disabled')
        + '>' + esc(v.title) + (v.available ? '' : ' · sold out') + '</option>';
    }).join('');
    return '<select class="ob-size-select" id="sz-' + rowId + '" aria-label="Select size">'
      + '<option value="" disabled selected>Size</option>'
      + opts + '</select>';
  }

  function currentRow() {
    var hasSale   = cfg.comparePrice && cfg.comparePrice > cfg.productPrice;
    var priceHtml = hasSale
      ? '<s class="ob-price-was">' + fmt(cfg.comparePrice) + '</s> <span class="ob-price-now">' + fmt(cfg.productPrice) + '</span>'
      : '<span class="ob-price-now">' + fmt(cfg.productPrice) + '</span>';

    return '<div class="ob-row ob-row--current">'
      + '<div class="ob-row-thumb">'
      + '<img src="' + esc(cfg.productImage) + '" alt="' + esc(cfg.productTitle) + '" width="64" height="64">'
      + '</div>'
      + '<div class="ob-row-info">'
      + (cfg.productVendor ? '<div class="ob-row-brand">' + esc(cfg.productVendor) + '</div>' : '')
      + '<div class="ob-row-name">' + esc(cfg.productTitle) + '</div>'
      + '<div class="ob-row-price">' + priceHtml + '</div>'
      + '</div>'
      + '<div class="ob-row-cta">'
      + '<span class="ob-in-cart-badge">'
      + '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="11" height="11" aria-hidden="true"><polyline points="1.5,7 5,10.5 12.5,3"/></svg>'
      + ' IN YOUR CART</span>'
      + '</div>'
      + '</div>';
  }

  function suggestionRow(slot) {
    var p          = slot.product;
    var cat        = slot.category;
    var isUnavail  = slot.available === false;
    var hasSale    = p.comparePrice && p.comparePrice > p.price;
    var mp         = maxPct();
    var saveCents  = mp > 0 ? Math.round(p.price * mp / 100) : 0;

    var priceHtml = hasSale
      ? '<s class="ob-price-was">' + fmt(p.comparePrice) + '</s> <span class="ob-price-now">' + fmt(p.price) + '</span>'
      : '<span class="ob-price-now">' + fmt(p.price) + '</span>';

    var saveHtml = (!isUnavail && saveCents > 0)
      ? ' <span class="ob-price-save">· save ' + fmt(saveCents) + '</span>'
      : '';

    var url = '/products/' + esc(p.handle);

    var ctaHtml = isUnavail
      ? '<span class="ob-sold-out-badge">SOLD OUT</span>'
      : '<div class="ob-size-wrap">' + sizeSelect(p.variants, cat) + '</div>'
        + '<button type="button" class="ob-btn-add" disabled data-cat="' + cat + '" aria-label="Add ' + esc(p.title) + ' to outfit">ADD +</button>';

    return '<div class="ob-row ob-row--suggestion' + (isUnavail ? ' ob-row--sold-out' : '') + '" data-category="' + cat + '" data-product-id="' + p.id + '">'
      + '<a class="ob-row-thumb ob-row-img-link" href="' + url + '" tabindex="-1" aria-hidden="true">'
      + '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="64" height="64" loading="lazy">'
      + '</a>'
      + '<div class="ob-row-info">'
      + (p.vendor ? '<div class="ob-row-brand">' + esc(p.vendor) + '</div>' : '')
      + '<a class="ob-row-name ob-row-name-link" href="' + url + '">' + esc(p.title) + '</a>'
      + '<div class="ob-row-price">' + priceHtml + saveHtml + '</div>'
      + '</div>'
      + '<div class="ob-row-cta">' + ctaHtml + '</div>'
      + '</div>';
  }

  function summaryHtml() {
    return '<div class="ob-summary">'
      + '<div class="ob-summary-line ob-summary-line--sub">'
      + '<span class="ob-sum-label">Total without deal</span>'
      + '<span class="ob-sum-val" id="ob-subtotal">' + fmt(cfg.productPrice) + '</span>'
      + '</div>'
      + '<div class="ob-summary-line ob-summary-line--deal" id="ob-disc-row" style="display:none">'
      + '<span class="ob-sum-label"><span class="ob-deal-badge">OUTFIT DEAL</span> <span id="ob-deal-pct"></span></span>'
      + '<span class="ob-sum-val ob-sum-val--green" id="ob-disc-val"></span>'
      + '</div>'
      + '<div class="ob-summary-line ob-summary-line--total">'
      + '<span class="ob-sum-label">Total</span>'
      + '<span class="ob-sum-val ob-sum-val--bold" id="ob-total">' + fmt(cfg.productPrice) + '</span>'
      + '</div>'
      + '<button type="button" class="ob-btn-checkout" id="ob-cta" disabled>'
      + '<svg class="ob-bag-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16" aria-hidden="true">'
      + '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>'
      + '</svg>'
      + '<span id="ob-cta-label">ADD OUTFIT TO CART · 1 ITEM</span>'
      + '</button>'
      + '<div class="ob-checkout-note">Outfit Deal applied automatically at checkout</div>'
      + '</div>';
  }

  function refresh() {
    var n        = countAdded();
    var t        = totals();
    var next     = getNextTier(n);
    var tiers    = cfg.tiers.slice().sort(function (a, b) { return a.count - b.count; });
    var maxCount = tiers.length ? tiers[tiers.length - 1].count : 4;

    var nudgeEl = document.getElementById('ob-nudge');
    var pctEl   = document.getElementById('ob-pct');
    var fillEl  = document.getElementById('ob-bar');

    if (nudgeEl) nudgeEl.textContent = next
      ? 'Add ' + (next.count - n) + ' more item' + (next.count - n > 1 ? 's' : '') + ' for ' + next.pct + '% off'
      : 'Bundle discount unlocked ✓';

    if (pctEl) {
      pctEl.textContent = t.pct > 0 ? t.pct + '% OFF' : '0% OFF';
      pctEl.classList.toggle('ob-pct-inactive', t.pct === 0);
      pctEl.classList.toggle('ob-pct-active',   t.pct > 0);
    }

    if (fillEl) {
      var fp = Math.min(100, Math.round(n / maxCount * 100));
      fillEl.style.width = fp + '%';
      fillEl.setAttribute('aria-valuenow', fp);
    }

    document.querySelectorAll('.ob-milestone').forEach(function (m) {
      m.classList.toggle('ob-milestone--reached', n >= parseInt(m.dataset.count, 10));
    });

    var subEl   = document.getElementById('ob-subtotal');
    var discRow = document.getElementById('ob-disc-row');
    var discVal = document.getElementById('ob-disc-val');
    var dealPct = document.getElementById('ob-deal-pct');
    var totalEl = document.getElementById('ob-total');

    if (subEl)   subEl.innerHTML = t.pct > 0 ? '<s>' + fmt(t.subtotal) + '</s>' : fmt(t.subtotal);
    if (discRow) discRow.style.display = t.pct > 0 ? '' : 'none';
    if (dealPct) dealPct.textContent = t.pct + '% off — save ' + fmt(t.discount);
    if (discVal) discVal.textContent = '−' + fmt(t.discount);
    if (totalEl) totalEl.textContent = fmt(t.total);

    var cta = document.getElementById('ob-cta');
    var lbl = document.getElementById('ob-cta-label');
    if (cta) cta.disabled = n <= 1;
    if (lbl) lbl.textContent = 'ADD OUTFIT TO CART · ' + n + ' ITEM' + (n > 1 ? 'S' : '');
  }

  function onSizeChange(select) {
    var cat   = select.id.replace('sz-', '');
    var row   = document.querySelector('[data-category="' + cat + '"]');
    var btn   = row && row.querySelector('.ob-btn-add');
    var vid   = select.value;
    var opt   = select.options[select.selectedIndex];
    var price = opt ? parseInt(opt.dataset.price, 10) : 0;

    if (vid && btn) {
      btn.disabled = false;
      if (chosen[cat]) {
        chosen[cat] = { variantId: parseInt(vid, 10), price: price };
        refresh();
      }
    } else if (btn) {
      btn.disabled = true;
    }
  }

  function onToggle(btn) {
    var cat    = btn.dataset.cat;
    var row    = document.querySelector('[data-category="' + cat + '"]');
    var select = document.getElementById('sz-' + cat);
    var opt    = select && select.options[select.selectedIndex];
    var price  = opt ? parseInt(opt.dataset.price, 10) : 0;
    var vid    = select ? select.value : null;

    if (btn.classList.contains('ob-btn-added')) {
      btn.classList.remove('ob-btn-added');
      btn.textContent = 'ADD +';
      chosen[cat] = null;
      if (row) row.classList.remove('ob-row--added');
    } else {
      if (!vid) return;
      btn.classList.add('ob-btn-added');
      btn.textContent = 'ADDED ✓';
      chosen[cat] = { variantId: parseInt(vid, 10), price: price };
      if (row) row.classList.add('ob-row--added');
    }
    refresh();
  }

  function openCartDrawer() {
    var cartEl = document.querySelector('cart-drawer');
    if (cartEl && typeof cartEl.open === 'function') {
      cartEl.open();
    } else {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.click();
    }
  }

  function renderCartThenOpen() {
    var cartDrawer = document.querySelector('cart-drawer');
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ id: cfg.productId, sections: sections });
        } else {
          openCartDrawer();
        }
      })
      .catch(function () {
        openCartDrawer();
      });
  }

  function addToCart() {
    var cta = document.getElementById('ob-cta');
    var lbl = document.getElementById('ob-cta-label');
    if (!cta || cta.disabled) return;

    cta.disabled = true;
    if (lbl) lbl.textContent = 'ADDING…';

    var anchorInput = document.querySelector('form[action^="/cart/add"] [name="id"]');
    var anchorVariantId = anchorInput ? parseInt(anchorInput.value, 10) : cfg.currentVariantId;

    var items = [{
      id: anchorVariantId,
      quantity: 1,
      properties: { _outfit_id: outfitId, _outfit: 'true' }
    }];

    Object.keys(chosen).forEach(function (cat) {
      if (chosen[cat]) {
        items.push({
          id: chosen[cat].variantId,
          quantity: 1,
          properties: { _outfit_id: outfitId, _outfit: 'true' }
        });
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () {
        if (lbl) lbl.textContent = 'ADDED ✓ — VIEW CART';
        cta.disabled = false;
        cta.onclick = function () { openCartDrawer(); };
        renderCartThenOpen();
      })
      .catch(function (err) {
        cta.disabled = false;
        var msg = (err && (err.description || err.message)) || '';
        if (lbl) lbl.textContent = msg && msg.length <= 60 ? msg : 'ERROR — TRY AGAIN';
      });
  }

  function init() {
    var root = document.getElementById('outfit-builder-root');
    if (!root) return;

    if (!slots.length) {
      root.innerHTML = '<div class="ob-empty">No outfit suggestions found.</div>';
      return;
    }

    var rows = slots.map(function (slot) { return suggestionRow(slot); }).join('');
    root.innerHTML = '<div class="ob-items">' + currentRow() + rows + '</div>' + summaryHtml();

    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('ob-size-select')) onSizeChange(e.target);
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.ob-btn-add');
      if (btn) { onToggle(btn); return; }
      if (e.target.closest('#ob-cta')) { addToCart(); return; }
    });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ── Inject after buy buttons ──────────────────────────────────────────────
  function injectAfterBuyButtons() {
    var outfitEl   = document.querySelector('.outfit-builder-section');
    var buyButtons = document.querySelector('.ProductForm__BuyButtons');
    if (!outfitEl || !buyButtons || !buyButtons.parentNode) return;
    buyButtons.parentNode.insertBefore(outfitEl, buyButtons.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(injectAfterBuyButtons, 100); });
  } else {
    setTimeout(injectAfterBuyButtons, 100);
  }

})();